import { apiClient } from "../../../services/axiosInstance";

export function postToggleFollowRequest({
  comicSlug,
  langId,
  chapter,
}: {
  comicSlug: string;
  langId: string;
  chapter: string;
}) {
  return apiClient.post(
    `/json/c/toggle-follow/${comicSlug}/${langId}/${chapter}/`,
  );
}

export function postToggleLikeRequest(comicSlug: string) {
  return apiClient.post(`/v1/comics/${comicSlug}/toggle-like`);
}

export function postToggleHideReadingHistoryRequest(comicId: number, hide: boolean) {
  return apiClient.post(`/v1/comics/${comicId}/toggle-hide-reading-history`, {
    meta: [],
    payload: { intent: hide ? 'hide' : 'show' }
  });
}
